import React from 'react'

import ResumeSubCard from './ResumeSubCard'
import MySkills from "./MySkills"
import Recommendations from "./Recommendations"

const ResumeCard = () => {
    return (
        <div className="card-inner animated" id="resume-card">
            <div className="card-wrap">

                <ResumeSubCard />

                <MySkills />

                <Recommendations/>

            </div>
        </div>
    );
}

export default ResumeCard;